export default __webpack_public_path__ + "static/media/hero.755f8265.png";